import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { NavService } from '../services/nav.service';
import { AuthService} from '../auth/auth.service';
import { TranslatorService } from '../services/translate.service';


@Component({
  selector: 'app-dpi',
  templateUrl: './dpi.component.html',
  styleUrls: ['./dpi.component.scss']
})
export class DpiComponent implements OnInit {
  ss:any;
  user:any;
  sended: boolean = false;
  dpiUrl: SafeResourceUrl;
  title = "Dpi";
  subTitle = "EDAC - Dpi";
  innerHeight: any;
  constructor(public navService: NavService, public translate: TranslatorService, private authService: AuthService) { }


  ngDoCheck() {

    if (this.sended == false) {
      var frame: HTMLIFrameElement = document.getElementById('DpiIframe') as HTMLIFrameElement;
      if (frame != null) {
        this.sended = true;
        frame.contentWindow?.postMessage('sstorage', this.ss);
        this.dpiUrl = environment.rootDpi + this.user.sub;
      }
    }

  }

  loadLabels(){
    this.translate.get('SIDEBAR.Dpi').subscribe(res => {
      this.title = res;
      this.subTitle = "EDAC - " + res;
    })
  }

  ngOnInit(): void {
    this.ss = window.sessionStorage;
    this.user =  this.authService.user();
    console.log('send message to iframe %o',this.ss,this.user);
    this.loadLabels();
    this.navService.setTitle(this.title);
    this.navService.setSubTitle(this.subTitle);
this.navService.setWikiKey('NODEF');
    let actions : any;
    actions = [
    ];
    this.navService.setActions(actions);
    this.innerHeight = (window.innerHeight - 74) + 'px';
  }

}


